import React from 'react';
import injectSheet from 'react-jss';

import { compose } from 'shared/helpers';

import { mixClasses as cx } from 'helpers';


/*
 * Section for Bento
 * TODO: Maybe remove, using repop for notifications now..
 */
const Section = ({position, children}) => {
  const moreCls  = {
    topLeft: '',
    topMid: 'items-center',
    topRight: '',
    bottomLeft: '',
    bottomMid: 'items-center',
    bottomRight: '',
  }[position] || '';

  // ba b--dashed

  return (
    <div className={cx('flex flex-column w-third h2', moreCls)}>
      {React.Children.toArray(children)}
    </div>
  );
};


/*
 * Bento
 */
const Bento = ({
  classes: cn,
  className,
  style = {},
  topLeft = [],
  topMid = [],
  topRight = [],
  bottomLeft = [],
  bottomMid = [],
  bottomRight = [],
}) => {

  return (
    <div
      style={style}
      className={cx(
        cn.root,
        className,
        'fixed flex flex-column justify-between absolute--fill pv3 ph4',
        'z-max',  // Very top!!
      )}
    >
      <div className={cx('flex w-100')}>
        <Section position="topLeft" children={topLeft} />
        <Section position="topMid" children={topMid} />
        <Section position="topRight" children={topRight} />
      </div>
      <div className={cx('flex w-100')}>
        <Section position="bottomLeft" children={bottomLeft} />
        <Section position="bottomMid" children={bottomMid} />
        <Section position="bottomRight" children={bottomRight} />
      </div>
    </div>
  );
};

const styles =  {
  root: {
    // background: 'lightblue',
    pointerEvents: 'none',  // http://stackoverflow.com/a/4839672/3479934
  },
};

export default compose(
  injectSheet(styles)
)(Bento);



// WEBPACK FOOTER //
// ./src/components/elems/Bento.js